export function ExportIcon() {
	return <svg width='13' height='13' viewBox='0 0 13 13' fill='none'
							xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M11.6667 5H8.33333V0H3.33333V5H0L5.83333 10.8333L11.6667 5ZM0 12.5V14.1667H11.6667V12.5H0Z'
			fill='#0088CC'/>
	</svg>;
}